// src/components/HeaderBar.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { apiGet, apiPost } from '../lib/apiClient';

export default function HeaderBar({ isSurveyLab = false }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await apiGet('/api/auth/me');
        if (!cancelled) setCurrentUser(res);
      } catch (_) {
        if (!cancelled) setCurrentUser(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleSignOut = async () => {
    try {
      await apiPost('/api/auth/signout');
    } catch (_) {
      // ignore failures; we'll just drop local state
    } finally {
      setCurrentUser(null);
      setMenuOpen(false);
      window.dispatchEvent(new CustomEvent('user:signedout'));
      // Hard reload to ensure state and schema-dependent data reset to public
      window.location.href = '/';
    }
  };

  return (
    <header className="landing-header" style={{ position: 'relative' }}>
      <h1
        className="logo"
        style={{ margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
      >
        <button
          type="button"
          className="header-link"
          onClick={() => navigate('/')}
          title="Go to getSurvey home"
          style={{ fontSize: '1em' }}
        >
          <BrandLogo size="lg" />
        </button>
        {isSurveyLab && (
          <span className="labs-badge" aria-label="Beta program status">
            Beta
          </span>
        )}
      </h1>
      {isSurveyLab && (
        <p className="logo-tagline" role="note">
          Fast anonymous feedback for teams and communities.
        </p>
      )}

      <div className="header-actions">
        <div style={{ position: 'relative' }}>
          <button
            aria-label="Open menu"
            title="Menu"
            onClick={() => setMenuOpen(v => !v)}
            className="about-button"
            style={{ padding: '6px 10px', fontSize: 18 }}
            >
              ☰
            </button>
            {menuOpen && (
              <div
              role="menu"
              style={{
                position: 'absolute',
                right: 0,
                top: 'calc(100% + 8px)',
                background: 'white',
                border: '1px solid #e5e7eb',
                borderRadius: 8,
                minWidth: 240,
                boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                zIndex: 1000,
                overflow: 'hidden'
              }}
            >
              {currentUser ? (
                <button
                  role="menuitem"
                  className="about-button"
                  style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', border: 0, background: 'transparent', cursor: 'pointer', whiteSpace: 'nowrap' }}
                  onClick={handleSignOut}
                >
                  Sign out ({currentUser.username || 'account'})
                </button>
              ) : (
                <button
                  role="menuitem"
                  className="about-button"
                  style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', border: 0, background: 'transparent', cursor: 'pointer', whiteSpace: 'nowrap' }}
                  onClick={() => { setMenuOpen(false); navigate('/signin'); }}
                >
                  Sign in
                </button>
              )}
              <button
                role="menuitem"
                className="about-button"
                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', border: 0, background: 'transparent', cursor: 'pointer', whiteSpace: 'nowrap' }}
                onClick={() => { setMenuOpen(false); navigate('/feedback'); }}
              >
                Submit Early Feedback
              </button>
              <button
                role="menuitem"
                className="about-button"
                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', border: 0, background: 'transparent', cursor: 'pointer', whiteSpace: 'nowrap' }}
                onClick={() => { setMenuOpen(false); navigate('/privacy/anonymous-id'); }}
              >
                ID Policy
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
